export const UserRoles = {
    ADMIN: 'ADMIN',
    REGULAR: 'REGULAR',
    GUEST: 'GUEST',
    TEMP: 'TEMPORARY',
    POTENTIAL: 'POTENTIAL',
    DINER_TEMP: 'DINER_TEMPORARY',
};
